'use client';

import React, { useEffect, useState } from "react";
import Image from "next/image";

export default function Preloader({ logoSrc = "/assets/Company/doortodoorbeauty.jpg", timeout = 1500 }) {
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf;
    let start = performance.now();

    function step(now) {
      const elapsed = now - start;
      const p = Math.min(100, Math.floor((elapsed / 1500) * 100));
      setProgress(p);
      if (p < 100) {
        raf = requestAnimationFrame(step);
      } else {
        setTimeout(() => setVisible(false), timeout);
      }
    }
    raf = requestAnimationFrame(step);

    return () => cancelAnimationFrame(raf);
  }, [timeout]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-rose-100 animate-fadeIn">
      <div className="flex flex-col items-center gap-6 animate-scaleIn">
        
        {/* Glowing ring */}
        <div className="relative w-32 h-32">
          <div className="absolute inset-0 rounded-full border-[6px] border-transparent border-t-pink-400 border-b-rose-300 animate-spin-slow blur-sm"></div>
          <Image
            src={logoSrc}
            alt="DoorToDoor Beauty"
            fill
            className="object-contain rounded-full shadow-xl"
            priority
          />
        </div>

        {/* Tagline */}
        <p className="text-gray-700 font-serif italic text-lg tracking-wide">
          Elevating Your Beauty Journey
        </p>

        {/* Progress bar */}
        <div className="w-64 bg-gray-200 rounded-full h-2 overflow-hidden shadow-inner">
          <div
            style={{ width: `${progress}%` }}
            className="h-full bg-gradient-to-r from-pink-400 via-rose-500 to-red-400 animate-shimmer"
          />
        </div>

        {/* Percentage */}
        <div className="text-sm text-gray-600 tracking-wider">{progress}%</div>
      </div>

      <style jsx>{`
        .animate-spin-slow {
          animation: spin 2.5s linear infinite;
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.6s ease-out;
        }
        .animate-shimmer {
          background-size: 200% 100%;
          animation: shimmer 2s infinite linear;
        }
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </div>
  );
}
